export default class PolicyAccommodationDetailModel {
  public policyId: number
  public includesAccommodation: boolean
  public includesTransportToAccommodation: boolean
  public accommodationExtraValue: number
}
